import Atendente from './Atendente';

export default Atendente;